import { FC } from 'react';
import { Stack } from '@wellstone-solutions/web';
import { Outlet } from 'react-router-dom';

import { Card } from '@components/ui/Card';

const AuthLayout: FC = () => {
  return (
    <Stack sx={styles.pageContainer}>
      <Card>
        <Outlet />
      </Card>
    </Stack>
  );
};

const styles = {
  pageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'auto',
    width: '100%',
  },
};

export { AuthLayout };
